/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import React__default from 'react';
import classNames from 'classnames';
import { d as _assignValue, e as _copyObject, b as _isPrototype, k as keys_1 } from '../_chunks/dep-dadffb76.js';
import '../_chunks/dep-9fe8d051.js';
import { _ as _baseRest } from '../_chunks/dep-aea8138c.js';
import { _ as _isIterateeCall } from '../_chunks/dep-d8b4285c.js';
import { i as isArrayLike_1 } from '../_chunks/dep-6b8f1e75.js';
import '../_chunks/dep-674c58f4.js';
import '../_chunks/dep-95834911.js';
import '../_chunks/dep-0e9724f2.js';
import '../_chunks/dep-f771ed13.js';
import '../_chunks/dep-cd7df551.js';
import '../_chunks/dep-41e2f4ed.js';
import '../_chunks/dep-818f0859.js';
import '../_chunks/dep-a4df350d.js';
import '../_chunks/dep-00b2fb56.js';

var baseRest = _baseRest,
  isIterateeCall = _isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner$1(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
      length = sources.length,
      customizer = length > 1 ? sources[length - 1] : undefined,
      guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}
var _createAssigner = createAssigner$1;

var assignValue = _assignValue,
  copyObject = _copyObject,
  createAssigner = _createAssigner,
  isArrayLike = isArrayLike_1,
  isPrototype = _isPrototype,
  keys = keys_1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function (object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});
var assign_1 = assign;

function withNativeProps(props, element) {
  var elementProps = element.props;
  var nativeProps = {};
  if (props.className) {
    nativeProps.className = classNames(elementProps.className, props.className);
  }
  if (props.style) {
    nativeProps.style = assign_1({}, elementProps.style, props.style);
  }
  keys_1(props).forEach(function (key) {
    if (key.startsWith("data-") || key.startsWith("aria-")) {
      nativeProps[key] = props[key];
    }
  });
  if (keys_1(nativeProps).length) {
    return /*#__PURE__*/React__default.cloneElement(element, assign_1({}, elementProps, nativeProps));
  }
  return element;
}

export { withNativeProps as default };
//# sourceMappingURL=withNativeProps.js.map
